<template>
  <div class="article-intro" :class="color">
    <div class="text-box">
      <slot/>
      <social-share/>
    </div>
  </div>
</template>

<script>
import SocialShare from "@/elements/SocialShare";
export default {
  name: "ArticleIntro",
  components: {SocialShare},
  props: {
    color: {
      type: String,
      default: 'blue'
    }
  }
}
</script>

<style scoped>
@media(min-width: 1000px) {
  .article-intro {
    position: sticky;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    top: 100vh;
    z-index: 2;
    height: 0;
    pointer-events: none;
    margin-bottom: calc(3% + 40px);
  }
  .text-box {
    position: relative;
    display: block;
    width: 400px;
    min-height: 500px;
    padding: 40px 34px 50px;
    background-color: white;
    z-index: 1;
    margin-right: 1000px;
    pointer-events: all;
    box-shadow: 0 10px 100px -30px rgba(0, 0, 0, 0.1);
  }
}

@media(max-width: 1540px) {
  .article-intro {
    justify-content: flex-start;
  }
  .text-box {
    margin-left: 60px;
    min-width: 380px;
  }
}

@media(max-width: 1199px) {
  .text-box {
    margin-left: 30px;
    min-width: 360px;
  }
}
@media(max-width: 999px) {
  .article-intro {
    position: relative;
    padding: 34px;
  }
  .article-intro:after {
    content: "";
    position: relative;
    display: block;
    height: 3px;
    border-radius: 2px;
    background-color: #102D61;
    margin: 36px 0 15px;
  }
  .pink.article-intro:after p {
    background-color: #C7125C;
  }
  .yellow.article-intro:after p {
    background-color: #FCC500;
  }
  .gradient.article-intro:after p {
    background: linear-gradient(70deg, #B1D995 0%, #3CB2B8 100%);
  }
  .text-box {
    margin-left: 0;
    min-width: 0;
  }
}
@media(max-width: 567px) {
  .article-intro {
    padding: 20px;
    background-color: #fff;
  }
}
.text-box >>> > ul {
  list-style: none;
  padding: 0;
  margin: 2em 0;
}
.text-box >>> > ul li {
  position: relative;
  margin: 0.6em 0;
  padding-left: 18px;
  font-weight: 500;
}
.text-box >>> > ul li:before {
  position: absolute;
  left: 0;
  font-family: "Icons", sans-serif;
  font-size: 14px;
  top: 2px;
}
.text-box >>> .social-share p {
  display: none;
}
.text-box >>> .social-share ul {
  margin-left: -6px;
}
</style>